import { ForwardedRef, forwardRef } from 'react';
import styles from '@components/Button/Button.styles';
import buttonsThemes from '@components/Button/themes';
import { TProps } from '@components/Button/typescript';
import Loading from '@components/Loading/Loading';
const Button = forwardRef(({
  variant = 'default',
  variantColor = 'brand',
  variantBackgroundColor = undefined,
  disabled = false,
  name = '',
  size = 'default',
  addSx = {},
  letterCase = 'none',
  fullWidth = false,
  loading = false,
  type = 'button',
  cy = '',
  onClick = () => undefined,
  children,
  active = false,
  addClassName = '',
  title = ''
}: TProps, ref?: ForwardedRef<HTMLButtonElement>) => <button ref={ref} type={type || 'button'} name={name} data-testid={cy} onClick={onClick} className={addClassName} title={title} sx={{
  ...styles.shared(variant || 'default', size, letterCase, fullWidth, disabled, loading),
  ...styles.variant(variant || 'default', variantColor || 'brand', variantBackgroundColor, size || 'default', active),
  ...addSx
}} disabled={disabled}>
      {variant && variantColor && loading && <span sx={styles.loadingWrapper(size)}>
          <Loading color={buttonsThemes.loading[variant][variantColor].color} />
        </span>}
      <span className="button-children-wrapper" sx={styles.childrenWrapper(loading)}>
        {children}
      </span>
    </button>);
Button.displayName = 'Button';
export default Button;